import { useRef } from 'react';
import { i18n as _i18n } from "@lingui/core";
import { Trans } from '@lingui/react';
import cx from 'classnames';
import { formNames, MktSelectors } from '@wkda/carlead-creation-form';
import { useTrackLeadFormEvent } from '@wkda/funnel-components';
import { useCarleadConfiguration } from '../hooks/useCarleadCreationConfiguration';
import { useCarleadFieldChangedTracking } from '../hooks/useCarleadFieldChangedTracking';
import { BaseField } from './BaseField';
import { textInputRenderer } from './fieldRenderers/textInputRenderer';
import { useStateMachineForFields } from './hooks/useStateMachineForFields';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function CarleadLicensePlate(_ref) {
  let {
    country,
    label = _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.label.licensePlate',
      message: "License plate"
    }),
    placeholder = _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.placeholder.licensePlate',
      message: "Complete your license plate number"
    }),
    className,
    onChange: _onChange,
    ...props
  } = _ref;
  const name = formNames.licensePlate;
  const {
    isFieldEnabled,
    stateFieldClassNames,
    sendSelect,
    sendFocus,
    fillInput
  } = useStateMachineForFields({
    name
  });
  const trackLeadFieldChanged = useCarleadFieldChangedTracking();
  const trackLeadFormEvent = useTrackLeadFormEvent();
  const internalPreviousValue = useRef('');
  const {
    licensePlateFallbackPath
  } = useCarleadConfiguration();
  function onFocus(e) {
    sendFocus();
    internalPreviousValue.current = e.target.value;
  }
  function onBlur(e) {
    if (internalPreviousValue.current !== e.target.value) {
      trackLeadFieldChanged(name, 'user');
    }
    sendSelect(e.target.value);
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "license-plate-field license-plate-field--" + country,
    children: [/*#__PURE__*/_jsx(BaseField, {
      label: label,
      name: name,
      MktSelector: MktSelectors.licensePlate,
      topContainerClassName: stateFieldClassNames,
      disabled: !isFieldEnabled,
      renderFieldWrapper: function (_ref2) {
        let {
          headerRenderer,
          fieldRenderer,
          belowRenderer,
          infoText
        } = _ref2;
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "license-plate-field__header",
            children: headerRenderer({
              label,
              name
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "license-plate-field__group",
            children: fieldRenderer({
              name
            })
          }), belowRenderer({
            name: name,
            text: infoText
          })]
        });
      },
      renderFieldComponent: function fieldRenderer(_ref3) {
        let {
          name
        } = _ref3;
        return textInputRenderer({
          id: name,
          name,
          placeholder,
          className: cx('license-plate-field__control', className),
          disabled: !isFieldEnabled,
          onFocus,
          onBlur,
          onChange(value) {
            fillInput(value);
          }
        });
      },
      ...props
    }), /*#__PURE__*/_jsx("div", {
      className: "license-plate-field__fallback",
      children: /*#__PURE__*/_jsx("a", {
        href: licensePlateFallbackPath,
        className: "license-plate-field__fallback-url",
        onClick: () => {
          trackLeadFormEvent('license-plate-unknown-click', 'user');
        },
        children: /*#__PURE__*/_jsx(Trans, {
          id: "carleadCreation.licensePlate.fallbackUrl"
        })
      })
    })]
  });
}